// ═══════════════════════════════════════════════════════════
// Toast 通知 — 队列管理，支持多条排队显示
// ═══════════════════════════════════════════════════════════

import { TIMEOUT } from '../config/constants.js';

const queue = [];
let showing = false;

function showNext() {
    if (queue.length === 0) {
        showing = false;
        return;
    }

    showing = true;
    const { message, type } = queue.shift();

    const toast = document.getElementById('toast');
    const toastMessage = document.getElementById('toastMessage');
    if (!toast || !toastMessage) return;

    // Reset all type classes, add current
    toast.className = 'toast-bar show ' + type;
    toastMessage.textContent = message;

    setTimeout(() => {
        toast.classList.remove('show');
        setTimeout(showNext, TIMEOUT.TOAST_ANIMATION);
    }, TIMEOUT.TOAST_DISPLAY);
}

export function showToast(message, type = 'error') {
    queue.push({ message, type });
    if (!showing) showNext();
}

export default showToast;
